import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { useSetState } from 'Utils/Helpers/Hooks';
import { useSelector, useDispatch } from 'react-redux';
import { editPatient, getPatients } from 'http/components/PatientService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetPatientData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditPatient({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { current } = useSelector((state) => ({
    current: state.staff.current,
  }));
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'نام و نام خانوادگی',
      value: '',
      icon: <icons.PersonSquare/>,
      force: true,
    },
    nCode: {
      id: "nCode",
      type: 'number',
      placeholder: 'کد ملی',
      value: '',
      icon: <icons.AppIndicator/>,
      force: false,
    },
    uniCode: {
      id: "uniCode",
      type: 'text',
      placeholder: 'شماره پرونده',
      value: '',
      icon: <icons.CardList/>,
      force: true,
    },
    mobile: {
      id: "mobile",
      type: 'number',
      placeholder: 'شماره موبایل',
      value: '',
      icon: <icons.Telephone/>,
      force: false,
    },
  });

  const onEnter = () => {
    setControls({name: { value: row.name } });
    setControls({uniCode: { value: row.uniCode } });
    setControls({nCode: { value: row.nCode } });
    setControls({mobile: { value: row.mobile } });
  }

  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  const setShowDialog = () => {
    setShow(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    const {name, nCode, uniCode, mobile} = controls;
    dispatch(HandleLoading(true));
    if(name.value !== '' && uniCode.value !== '') {
      const response = await editPatient(row.id, name.value, nCode.value, uniCode.value, mobile.value);
      if(response.status) {
        const response2 = await getPatients();
        if(response2.status) {
            await dispatch(SetPatientData(response2.data))
            enqueueSnackbar('اطلاعات بیمار با موفقیت ویرایش شد', {variant: 'success'});
            setShow(false);
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است، فیلد‌های ستاره دار الزامی می باشند', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <GridActionsCellItem
        icon={<icons.Pencil size={16}/>}
        label="Edit"
        onClick={setShowDialog}
        disabled={!current[2][2]}
        hidden={!current[2][2]}
      />
      {
          show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-patient-edit"
        >
          <DialogTitle className='edit-mode'>
            {`ویرایش بیمار ${row.name.substring(0, row.name.indexOf(" "))}`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            { 
              show &&
              <DialogContentText id="alert-dialog-slide-patient-edit">
                {
                  Object.keys(controls).map((key, index) => {
                    return (
                      <Inputer
                        key={`inputer_${controls[key].id}`}
                        id={controls[key].id}
                        type={controls[key].type}
                        placeholder={controls[key].placeholder}
                        value={controls[key].value}
                        setValue={setControlsValue.bind(this)}
                        force={controls[key].force}
                        icon={controls[key].icon}
                        className={'mb-2'}
                      />
                    )
                  })
                }
              </DialogContentText>
            }
          </DialogContent>
          <DialogActions>
            <CButton
              text={'ویرایش بیمار'}
              icon={<icons.Pencil/>}
              onClick={onFinish}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
